'use strict';

declare var pdfMake: any;

module Patersons {

    export interface MarketOrdersScope extends ng.IScope {
        accounts: Array<Account>;
        selectedAccount: Account;
        selectedAccountTotals: SelectedAccountTotal;
        events: MarketOrdersCtrl;
        isLoading: boolean;
        reportError: string;
        startDate: Date;
        endDate: Date;
        generatedDate: Date;
        reverse: boolean;
        predicate: string;
        filename: string;
        csvData: Array<any>;
        filter: any;
        isDownloadReady: boolean;
        isError: boolean;
        hasData: boolean;
    }

    //export class MarketOrdersCtrl extends AbstractController {
    export class MarketOrdersCtrl extends PortfolioBaseCtrl {
        scope: Patersons.MarketOrdersScope;
        portfolioService: Patersons.PortfolioService;
        pdfBuilderService: Patersons.PDFBuilderService;
        static $inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', '$filter', 'portfolioService','navigationService', 'pdfBuilderService'];

        constructor($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, $filter, portfolioService, navigationService, pdfBuilderService) {
            super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.scope.filter = $filter;
            this.scope.events = this;
            this.portfolioService = portfolioService;
            this.scope.accounts = new Array<Account>();
            this.scope.reverse = true;
            this.scope.predicate = "orderDate";
            this.pdfBuilderService = pdfBuilderService

            this.scope.endDate = moment().toDate();
            this.scope.startDate = moment().subtract(30, 'days').toDate();
            this.scope.isError = false;
            this.scope.hasData = false;

            this.scope.csvData = [];
            this.load();
        }

        order(predicate) {
            this.scope.reverse = (this.scope.predicate === predicate) ? !this.scope.reverse : false;
            this.scope.predicate = predicate;
        }

        hasOrdersInRange(): boolean {
            let start: moment.Moment = moment(this.scope.startDate);
            let end: moment.Moment = moment(this.scope.endDate);

            return this.scope.selectedAccount &&
                this.scope.selectedAccount.marketOrders &&
                this.scope.selectedAccount.marketOrders.some(m => moment(m.orderDate).isBetween(start, end, 'days', '[]'));
        }

        buildTableBody(data, columns, headers) {
            var body = [];
            body.push(headers);
            data.forEach(row => {
                var dataRow = [];
                columns.forEach(column => {
                    dataRow.push(row[column].toString());
                });
                body.push(dataRow);
            });
            return body;
        }

        table(data, columns, headers) {
            return {
                table: {
                    headerRows: 1,
                    body: this.buildTableBody(data, columns, headers)
                }
            };
        }

        downloadCsv() {
            console.info('Download CSV');
            let account = this.scope.selectedAccount;
            let startDate = this.scope.startDate;
            let endDate = this.scope.endDate;
            let fileName = this.getFileName();

            this.makeCsv(fileName);
        }

        private makeCsv(filename: string): void {
            let account = this.scope.selectedAccount;
            let startDate = this.scope.startDate;
            let endDate = this.scope.endDate;
            let topLine = ReportDownloadService.getCsvTopLine(account, new Date(), startDate, endDate, undefined);
            let csvBuilder = new CsvBuilder();
            csvBuilder.setFilename(filename)
                .setTopLine(topLine)
                .setHeaders(this.getHeadings())
                .setData(this.getFormattedData())
                .build();
        }

        private getFields() {
            return ["orderDate", "orderNumber", "orderStatus", "type", "quantity", "securityCode", "securityDescription", "limit", "quantityMatched", "quantityAllocated", "unfilled"];
        }

        private getHeadings(): string[] {
            return ["Date", "Order Number", "Status", "Type", "Units", "Security Code", "Description", "Limit", "Matched", "Allocated", "Unbooked"];
        }

        private makeOrdersPdf(account: Account, filename: string): any {
            let rawData = this.scope.selectedAccount.marketOrders;
            var data = this.getFormattedDataPdf(rawData);
            let asAtDateStr = moment(new Date()).format("D MMM YYYY");
            var startDate = moment(this.scope.startDate).format("D MMM YYYY");
            var endDate = moment(this.scope.endDate).format("D MMM YYYY");
            let timestamp = moment.tz(this.scope.generatedDate, 'Australia/Sydney').format("h:mm AEST a [on] D MMM YYYY");

            this.pdfBuilderService.newPdfBuilderInstance().then((pdfBuilder) => {
                pdfBuilder
                    .setTitle('Market Orders')
                    .addHeaderTableRow('Adviser:',account.adviserName, '','')
                    .addHeaderTableRow('Account:',account.accountId, '','')
                    .addHeaderTableRow('From Date:', moment.tz(startDate, 'Australia/Sydney').format('h:mm a [AEST on] D MMM YYYY'), '', '')
                    .addHeaderTableRow('To Date:', moment.tz(endDate, 'Australia/Sydney').format('h:mm a [AEST on] D MMM YYYY'), '', '')
                    .addHeaderTableRow('Report Generated at:', moment.tz(new Date(), 'Australia/Sydney').format('h:mm a [AEST on] D MMM YYYY'), '', '')
                    .addTable(
                      'Market Orders',
                      data,
                      this.getRawHeader(),
                      this.getPdfHeader(),
                      null,
                      false)
                    .setFilename(filename)
                    .build();
            })            
            

        }

        downloadPdf() {
            console.info('Download PDF');
            let fileName = this.getFileName();
            this.makeOrdersPdf(this.scope.selectedAccount, fileName);
        }

        getRawHeader() {
            return ["orderDate", "orderNumber", "orderStatus", "type", "quantity", "securityCode", "securityDescription", "limit", "quantityMatched", "quantityAllocated", "unfilled"];//, "accountNumber", "adviserCode", "reportTitle", "dateRangeSelected"];
        }

        getPdfHeader() {
            /*return [
            { text: "Date", style: "tableHeader" },
            { text: "Order Number", style: "tableHeader" },
            { text: "Status", style: "tableHeader" },
            { text: "Type", style: "tableHeader" },
            { text: "Units", style: "tableHeader" },
            { text: "Security Code", style: "tableHeader" },
            { text: "Description", style: "tableHeader" },
            { text: "Limit", style: "tableHeader" },
            { text: "Matched", style: "tableHeader" },
            { text: "Allocated", style: "tableHeader" },
            { text: "Unbooked", style: "tableHeader" }
          ];*/
          return [
            "Date",
            "Order Number",
            "Status",
            "Type",
            "Units",
            "Security Code",
            "Description",
            "Limit",
            "Matched",
            "Allocated",
            "Unbooked"
          ];
        }

        getFileName() {
            var accountId = this.scope.selectedAccount.accountId;
            var startDate = moment(this.scope.startDate).format("YYYY-MM-DD");
            var endDate = moment(this.scope.endDate).format("YYYY-MM-DD");
            return accountId + "-MarketOrders-" + startDate + "_" + endDate;
        }

        getSummaryText = function() {
            var text = "Report generated at " +
                moment.tz(this.scope.generatedDate, 'Australia/Sydney').format('h:mm a') +
                " AEST on " +
                moment.tz(this.scope.generatedDate, 'Australia/Sydney').format('D MMM YYYY') + ".";
            return text;
        }

        getFormattedDataPdf(data) {
            var startDate = this.scope.startDate;
            var endDate = this.scope.endDate;
            var filtered = this.scope.filter('dateFilter')(data, 'orderDate', startDate, endDate);
            var pdfData = angular.copy(filtered);
            pdfData.map((order) => {
                delete order.id;
                delete order.investorPortfolioId;
                order.orderDate = moment(order.orderDate).format("DD-MM-YYYY");
            });
            return pdfData;
        }
        getFormattedData() {
            let data = this.scope.selectedAccount.marketOrders;
            var accountId = this.scope.selectedAccount.accountId;
            var accountName = this.scope.filter("accountName")(this.scope.selectedAccount.designation ? this.scope.selectedAccount.accountName+ ' '+ this.scope.selectedAccount.designation : this.scope.selectedAccount.accountName)
            var adviserCode = this.scope.selectedAccount.adviserCode;
            var startDate = this.scope.startDate;
            var endDate = this.scope.endDate;
            this.scope.filename = this.getFileName();
            var filtered = this.scope.filter('dateFilter')(data, 'orderDate', startDate, endDate);
            var csvData = angular.copy(filtered);
            const fields = this.getFields();
            csvData.map((order) => {
                delete order.id;
                delete order.investorPortfolioId;
                order.orderDate = moment(order.orderDate).format("YYYY-MM-DD");
                order.accountNumber = accountId;
                order.adviserCode = adviserCode;
                order.reportTitle = "Market Orders for " + accountName;
                order.dateRangeSelected = startDate + " to " + endDate;
                return fields.map(field => order[field])
            });
            return csvData;
        }

        load() {
            this.scope.isLoading = true;
            this.portfolioService.getCombinedPortfolioData()
                .then((result) => {
                    this.scope.$apply(() => {
                        this.scope.accounts = result;
                        this.scope.isLoading = false;
                    });
                });
        }

        loadMarketOrders(accountId: string, startDate: Date, endDate: Date) {

            this.scope.selectedAccount = this.scope.accounts.filter(a => a.accountId == accountId)[0];
            this.scope.startDate = startDate;
            this.scope.endDate = endDate;
            this.scope.generatedDate = new Date();
            this.scope.isError = false;
            this.scope.hasData = false;

            // Ensure the date range is inclusive
            this.scope.startDate.setHours(0, 0, 0, 0);
            this.scope.endDate.setHours(23, 59, 59, 0);

            this.scope.isLoading = true;
            this.scope.isDownloadReady = false;
            this.portfolioService.getMarketOrders(this.scope.selectedAccount.accountId)
                .then((result) => {
                    this.scope.selectedAccount.marketOrders = result;
                    this.scope.isDownloadReady = true;
                    this.scope.isError = false;
                    this.scope.hasData = true;
                },
                (reason) => { // error handling
                    //this.scope.reportError = reason.data.message;
                    this.scope.selectedAccount.marketOrders = null;
                    this.scope.isDownloadReady = true;
                    this.scope.isError = true;
                    this.scope.hasData = false;
                })
                .finally(() => {
                    this.scope.isLoading = false;
                });
        }

    }
}
